import React from 'react';
import BookingPreview from './BookingPreview'
import StaffBlockoutDatePreview from './StaffBlockoutDatePreview'
import StatusDot from './StatusDot'
import bookingsForStaffMember from '../helpers/bookings_for_staff_member'
import bookingsForDate from '../helpers/bookings_for_date'
import blockoutDatesForStaffMember from '../helpers/blockout_dates_for_staff_member'
import blockoutDatesForDate from '../helpers/blockout_dates_for_date'
import staffUtilizationStatus from '../helpers/staff_utilization_status'


const UtilizationCell = ({ date, staffMember, eventBookings, staffBlockoutDates, onClickBooking }) => {
  const currentBookings = bookingsForDate(date, bookingsForStaffMember(staffMember, eventBookings))
  const currentStaffBlockoutDates = blockoutDatesForDate(date, blockoutDatesForStaffMember(staffMember, staffBlockoutDates))

  const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' })
  const availabilityForDayOfWeek = staffMember.attributes[`available${dayOfWeek}`]
  const descriptionForDayOfWeek = staffMember.attributes[`available${dayOfWeek}Description`]
  const status = staffUtilizationStatus({ availabilityForDayOfWeek, bookingCount: currentBookings.length, blockoutCount: currentStaffBlockoutDates.length })

  const TopRightSection = () => (
    <StatusDot status={status} title={status} alt={status} aria-label={status} />
  )

  const TopLeftSection = () => (
    <>
      { currentBookings.map((booking) => (
        <div className="mb-1" key={booking.id}>
          <BookingPreview booking={booking} className="small" onClick={onClickBooking} />
        </div>
      ))}
    </>
  )

  const BottomSection = () => {
    if(currentStaffBlockoutDates.length > 0) {
      return (
        <>
          { currentStaffBlockoutDates.map((staffBlockoutDate) => (
            <div className="mb-1 small text-muted" key={staffBlockoutDate.id}>
              <div>{ staffBlockoutDate.attributes.reason || "Blockout" }</div>
            </div>
          ))}
        </>
      )
    }
    else if(availabilityForDayOfWeek === "partial") {
      return (
        <div className="mb-1">
          <div className="text-muted small">{ descriptionForDayOfWeek }</div>
        </div>
      )
    }
    else if(availabilityForDayOfWeek === "no") {
      return (
        <div className="mb-1">
          <div className="text-muted small">Out { dayOfWeek }s</div>
        </div>
      )
    }
    else {
      return null
    }
  }



  return (
    <td>
      <div className="d-flex justify-content-between align-items-start">
        <div className="flex-grow-1 me-1">
          <TopLeftSection />
        </div>
        <div className="ms-1 me-1">
          <TopRightSection />
        </div>
      </div>
      { (status == "partial" || status == "unavailable") && (
        <div className="border-top mt-2 pt-2">
          <BottomSection />
        </div>
      )}
    </td>
  )
}
export default UtilizationCell
